/**
 * Shared Google Fonts list — single source of truth for all font pickers.
 * ~20 fonts per category, chosen by popularity (Google Fonts analytics).
 */

export interface FontGroup {
  label: string;
  fonts: string[];
}

export const FONT_GROUPS: FontGroup[] = [
  {
    label: 'Bezszeryfowe (Sans-Serif)',
    fonts: [
      'Inter', 'Roboto', 'Open Sans', 'Lato', 'Montserrat',
      'Poppins', 'Nunito', 'Raleway', 'Ubuntu', 'Rubik',
      'Work Sans', 'DM Sans', 'Outfit', 'Manrope', 'Plus Jakarta Sans',
      'Mulish', 'Barlow', 'Quicksand', 'Cabin', 'Karla',
    ],
  },
  {
    label: 'Szeryfowe (Serif)',
    fonts: [
      'Merriweather', 'Playfair Display', 'Lora', 'Roboto Slab', 'PT Serif',
      'Noto Serif', 'Source Serif 4', 'Libre Baskerville', 'EB Garamond', 'Crimson Text',
      'Cormorant Garamond', 'Bitter', 'Alegreya', 'Vollkorn', 'Spectral',
      'Literata', 'IBM Plex Serif', 'Gelasio', 'Newsreader', 'Cardo',
    ],
  },
  {
    label: 'Dekoracyjne (Display)',
    fonts: [
      'Bebas Neue', 'Abril Fatface', 'Lobster', 'Pacifico', 'Righteous',
      'Alfa Slab One', 'Permanent Marker', 'Satisfy', 'Dancing Script', 'Great Vibes',
      'Caveat', 'Shadows Into Light', 'Comfortaa', 'Fredoka', 'Bungee',
      'Titan One', 'Sigmar One', 'Passion One', 'Bangers', 'Lilita One',
    ],
  },
  {
    label: 'Monospace',
    fonts: [
      'Fira Code', 'JetBrains Mono', 'Source Code Pro', 'Roboto Mono', 'IBM Plex Mono',
      'Space Mono', 'Ubuntu Mono', 'Inconsolata', 'Noto Sans Mono', 'Red Hat Mono',
      'DM Mono', 'Courier Prime', 'Overpass Mono', 'Anonymous Pro', 'Azeret Mono',
      'Martian Mono', 'Major Mono Display', 'Share Tech Mono', 'Cutive Mono', 'Nova Mono',
    ],
  },
  {
    label: 'Nagłówkowe (Heading)',
    fonts: [
      'Oswald', 'Josefin Sans', 'Lexend', 'Sora', 'Space Grotesk',
      'Archivo', 'Fira Sans', 'IBM Plex Sans', 'Noto Sans', 'Exo 2',
      'PT Sans', 'Source Sans 3', 'Nunito Sans', 'Titillium Web', 'Yanone Kaffeesatz',
      'Fjalla One', 'Anton', 'Russo One', 'Teko', 'Saira', 'Rajdhani',
    ],
  },
];

/** Flat list of all fonts (for simple pickers like FontFamilyField) */
export const ALL_FONTS: string[] = FONT_GROUPS.flatMap((g) => g.fonts);

/** Deduplicated, sorted flat list */
export const ALL_FONTS_SORTED: string[] = [...new Set(ALL_FONTS)].sort();
